import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'GlampingGuides',
  setup(__props) {

const GLAMPING_GUIDES = [
  {
    title: 'Glamping guides',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/4/image/private/s--zCxTwzLB--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1643095496/653994_y3drh4.jpg',
    url: '/guides/glamping/',
  },
  {
    title: 'Types of glamping',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/3/image/private/s--Z5EHEGDc--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1646481127/478142_typl1h.jpg',
    url: '/guides/glamping/types/',
  },
  {
    title: 'Top Tips For Glamping With A Dog',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/4/image/private/s--sjZCA9Cs--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1650310644/pexels-cottonbro-5365048_vdvnt5.jpg',
    url: '/guides/glamping/glamping-with-dogs/',
  },
  {
    title:
      'Budget glamping: how to cut costs while camping in style with Pitchup',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/5/image/private/s--SHc-teQL--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1650962390/673335_tn9hz1.jpg',
    url: '/guides/glamping/budget/',
  },
  {
    title: '9 of the best camping and glamping pods in the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/2/image/private/s--TiJ_em4T--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1646516094/loch-tay-highland-lodges-12_p7wp6g.jpg',
    url: '/guides/glamping/types/glamping-and-camping-pods/',
  },
  {
    title: 'The best glampsites for yurt holidays In the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/1/image/private/s--yB0bpkVV--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1646569722/yang-shuo-_Zbbs4muqkQ-unsplash_lt9ciz.jpg',
    url: '/guides/glamping/types/yurts/',
  },
  {
    title: 'Best geodesic dome holidays in the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/5/image/private/s--zHx-OYCD--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1649934083/dome_jjmicc.jpg',
    url: '/guides/glamping/types/dome-tents/',
  },
  {
    title: '10 of the best shepherd’s hut stays in the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/3/image/private/s--1gMQ6hyv--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1646770948/wood-g7e6d8f799_1280_ccu83n.jpg',
    url: '/guides/glamping/types/shepherd-huts/',
  },
  {
    title: 'Best tipi holidays in the UK',
    imgUrl:
      '/cdn-cgi/image/format=auto,fit=scale-down,quality=50,w=112/images/2/image/private/s--Etke2CDA--/c_limit,h_2400,w_3200/e_improve,fl_progressive/q_auto/b_rgb:000,g_south_west,l_pitchup.com_wordmark_white_watermark,o_15/v1649933739/tipe-3449759_1280_ecrsvc.jpg',
    url: '/guides/glamping/types/tipi-and-wigwams/',
  },
]

return { __sfc: true,GLAMPING_GUIDES }
}

})